import { inject, observer } from 'mobx-react';
import { ActionsStoreType } from 'models/ActionsStore';
import { ApplicationStoreType } from 'models/ApplicationStore';
import { DataStoreType } from 'models/DataStore';
import { ProjectsStoreType } from 'models/ProjectsStore';
import { useIntl } from 'react-intl';
import { ROUTE_FIRE } from 'utils/constants/routes';
import ActionOverlayButton from './ActionOverlayButton';

function HypothesisButton({
  dataStore,
  actionsStore,
  projectsStore,
  applicationStore
}: {
  dataStore?: DataStoreType;
  actionsStore?: ActionsStoreType;
  projectsStore?: ProjectsStoreType;
  applicationStore?: ApplicationStoreType;
}) {
  const intl = useIntl();
  let disabled = false;
  let intlId: string;
  let intlVars: { count: number; count2: number };

  const organizationId = dataStore!.currentOrganizationId!;
  const projectId = dataStore!.currentProjectId!;
  const painpointIds = actionsStore!.selectedIds.Painpoint;
  const benchmarkIds = actionsStore!.selectedIds.Benchmark;
  const isFireContext = location.pathname.includes(ROUTE_FIRE);
  const fireId = isFireContext ? dataStore?.fire?.id : undefined;

  if (
    benchmarkIds.length <
      dataStore!.currentProject?.aiSelectLimits.minBenchmarks! ||
    painpointIds.length <
      dataStore!.currentProject?.aiSelectLimits.minPainpoints!
  ) {
    disabled = true;
    intlVars = {
      count: dataStore!.currentProject?.aiSelectLimits.minBenchmarks!,
      count2: dataStore!.currentProject?.aiSelectLimits.minPainpoints!
    };
    intlId = 'create hypotheses not enough benchmarks';
  } else if (
    benchmarkIds.length >
      dataStore!.currentProject?.aiSelectLimits.maxBenchmarks! ||
    painpointIds.length >
      dataStore!.currentProject?.aiSelectLimits.maxPainpoints!
  ) {
    disabled = true;
    intlVars = {
      count: dataStore!.currentProject?.aiSelectLimits.maxBenchmarks!,
      count2: dataStore!.currentProject?.aiSelectLimits.maxPainpoints!
    };
    intlId = 'create hypotheses too many benchmarks';
  }

  return (
    <ActionOverlayButton
      label={intl.formatMessage({ id: 'Create hypotheses' })}
      iconName="ai"
      disabled={dataStore?.project?.reachedHypothesisLimit}
      onClick={async () => {
        if (!isFireContext && !dataStore?.project?.briefing.completed) {
          applicationStore!.setAiUnavailable(true);
          return;
        }
        if (disabled) {
          applicationStore!.setFlashMessage(
            intl.formatMessage(
              {
                id: intlId
              },
              intlVars
            ),
            'inlineError'
          );
          return;
        }

        try {
          const response = await projectsStore!.generateHypothesesByAi(
            organizationId,
            projectId,
            painpointIds,
            benchmarkIds,
            fireId
          );
          if (!response.success) {
            applicationStore!.setFlashMessage(
              intl.formatMessage({ id: 'AI create error' }),
              'error'
            );
          }
        } catch (error: any) {
          applicationStore!.setFlashMessage(
            intl.formatMessage({
              id: 'hypotheses search failed error'
            }),
            'error'
          );
        }
      }}
    />
  );
}

export default inject(
  'dataStore',
  'actionsStore',
  'projectsStore',
  'applicationStore'
)(observer(HypothesisButton));
